<script setup lang="ts">
import { cn } from '@/utils/utils';

const props =defineProps<{
  order?: number;
  class?: string;
}>();
</script>

<template>
  <div 
    :class="cn([
      'flex-1 flex items-center justify-center gap-2 md:flex-row flex-col',
      `order-${order || 0}`,
      props.class
    ])"
  >
    <slot></slot>
  </div>
</template>
